
import { ref, reactive, inject, shallowRef, onActivated,watch, computed ,onMounted } from 'vue';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { Toast } from "vant";
import Header from "@/components/header/header.vue";
import AfterGoodsCard from "./component/afterGoodsCard.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import KiliButton from "@/components/KiliButton.vue";
import AfterType  from "./component/afterType.vue";
import Sku from "@/components/sku/sku.vue";
import afterFileRemark from "./component/afterFileRemark.vue";
import { getFilePath,getRuleUrl } from '@/hooks/index'
export default {
    name: 'afterSaleInfo',
    components: { Header, AfterGoodsCard, BottomBtn, KiliButton, AfterType, Sku,afterFileRemark },
    setup() {
        const $http: any = inject("$http");
        const $store: any = inject("$store");
        const router = useRouter()
        const route = useRoute()
        let refForm = ref()
        let SkipPath = ref('/afterSale')
        // 商品信息
        let goodsData:any = ref([])
        /**  是否可批量操作，当为true是则不能操作商品数量,目前可批量操作只会在未发货时存在,发货后只能操作某一个商品的数量 */
        let isBatOnly = ref($store.getAfterBat())
        let showAction = ref(false) // 是否显示单选弹窗
        /** 售后类型 1：退款退货 2：退款 3.维修 4.换货 */
        let serviceType = ref({
            type: '',// 选中的售后服务类型
            title: '',// 选中的售后服务类型 标题
        })
        let reasonRad = ref('') // 选中的单选框值
        let statusVal:any = reactive({
            id: '',
            title: ''
        }) // 到货情况选中内容
        let reasonVal = reactive({
            id: '',
            title: ''
        }) // 售后原因内容
        // 单选框数据
        let reasonList:any = ref([])
        let reasonAllList:any = ref([])
        let popTitle = ref('Reason for return') // 单选弹窗标题
        // 地址数据
        let addressData: any = ref([])
        const fileList = ref([
            {
                content:'https://image.kilimall.com/kenya/aftersale/temp/productCondition.jpg',
                attach_type: 1,
                isGive: true
            },
            {
                content:'https://image.kilimall.com/kenya/aftersale/temp/outerPackage_new.jpg',
                attach_type: 1,
                isGive: true
            }
        ]);// 编辑下，进行图片视频返显的数据
        let skuShow = ref(false) // 是否显示sku
        let orderId = ref('')  //售后类型中存储的订单id
        let checksId = ref('')  //售后审核单id 编辑时需要用到
        let goods: any = shallowRef({}) // sku商品详情信息
        let selectGoods:any = ref({}) 
        // 表单数据
        let infoData = ref({
            statusVal: "",
            reasonVal: "",
            KShVal: 0,
            teaxAreaVal: "",
        })
        let addressMsg = ref('')
        let imgPathData:any = ref({}) 
        let showDialog = ref(false)
        let showaMountDialog = ref(false)
        let maxKSH: any = ref(0) // 当前最大可输入金额
        /**图片/视频规格内容  fileStorage数组内对象： 
         * {
         * content: '', // 上传时返回的文件拼接路径
            attach_type: 1, // 文件类型 1：图片 2：视频
            }
         */
        let fileStorage:any = ref([]) 
        let phoneCode = ref('') // 手机号码地区区号
         let btnData = ref([
           {
                plain: true,
                textColor: '#333333',
                bordersColor: '#999999',
                radiusSize: '6px',
                title: 'Cancel',
            },
            {
                plain: false,
                textColor: '#E04545',
                bordersColor: '#E04545',
                radiusSize: '6px',
                title: 'Apply',
                loading:false
            },
        ])
        let serviceTypeList:any = ref([])
        let skuId = ref(0) // 获取sku组件所需数据的商品id
        let selectType = ''  // 当前操作的选项-是操作到货状态/售后原因项/售后类型
        let isAddCart = ref(false) // 是否点击了 sku组件的ok按钮
        let variation = ref(true) 
        let ruleUrl = ref('') 
        let kshInputRef:any = ref(null)
        let afterInfo:any = [] // 售后类型中的商品数据
        let defaultMaxKSU:number = 0 // 统计的当前未调整数量前的所有商品的最大金额之和
        // let amountVer = false // 是否要进行金额的二次确认
        const afterGoodsData = $store.getAfterSaleGoods()
        const needKSH = computed(()=>{
            // 是否需要传金额给接口 为退货退款或退款时传金额
            return serviceType.value.type == '2'||serviceType.value.type == '1'
        })
        if (common.getStorage('site')) {
            phoneCode.value = common.getStorage('site').telecode
        }
        onMounted(()=>{
            // 获取视频/图片拼接路径及格式信息
                getFilePath().then((res:any)=>{
                    imgPathData.value = res
                })
        })
        // 校验当前输入金额 只能是整数和保留后两位数 并且不能大于当前可输入的最大金额
        const formatter = (value:any) => {
            let num = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')
            if(num <= 0) return ''
            if((num >= maxKSH.value)&&maxKSH.value>0){
                return maxKSH.value
            }else{
               return num
            }
        }
        // 获取当前订单id下的可售后类型
        const getAfterSaleType = async (goodsId:any,checkId?:any,applyInfo?:any) => {
            let typeDefault = [
                {
                    id:'1',
                    title: 'Return & Refund',
                    currentShow: 'support_return_refund'
                },
                {
                    id:'2',
                    title: 'Refund',
                    currentShow: 'support_refund'
                },
                // {
                //     id:'3',
                //     title: 'Repair',
                //     currentShow: 'support_repair'
                // },
                {
                    id:'4',
                    title: 'Exchange',
                    currentShow: 'support_exchange'
                },
            ]
            let params: any = {
                id: goodsId,
                check_id:checkId
            }
            await $http.getAfterSaleTypeList(params).then((res: any) => {
                if (res.code === 200) {
                    let data = JSON.parse(JSON.stringify(res.data))
                    for (let i in data.available_service) {
                        if (data.available_service[i] && i != "bat_only") {
                            serviceTypeList.value.push(...typeDefault.filter(item => item.currentShow == i))
                        }
                    }
                    afterInfo = res.data.orders
                    // 商品信息可能是对象,也可能是数组,最终都将其转换为数组,这样不管是其为对象时,嵌套了几个对象,都能正常显示
                    let arr:any = []
                    if(Object.prototype.toString.call(afterInfo[0].order_goods) === '[object Object]'){
                        afterInfo.forEach((item:any)=>{
                            for(let keys in item.order_goods){
                               arr.push(item.order_goods[keys])
                            }
                        })
                       goodsData.value = arr
                    }else{
                        afterInfo.forEach((item:any)=>{
                            arr = [].concat(arr,item.order_goods)
                        })
                        goodsData.value = arr
                    }
                    goodsInitFn(goodsData.value[0].sku_sn)
                    orderId.value = goodsData.value[0].id
                    isBatOnly.value = data.available_service['bat_only']
                    let max = 0
                    goodsData.value.forEach((item: any) => {
                        item.editNum = applyInfo.product_num // 对编辑过的商品数量进行反显
                        // 1.当前是批量操作情况下,最大金额为所有的商品最大金额之和 2.不是批量操作时,取当前的 editNum 作为价格数组的遍历条件最大值然后计算价格之和作为最大可申请金额
                        if(isBatOnly.value){
                            max += item.max_money
                        }else{
                            for(let i = 0;i < item.editNum;i++){
                                max += Number(item.extra[i].pay_price)
                            }
                        }
                         defaultMaxKSU += item.max_money
                    });
                    maxKSH.value = max
                }else{
                    Toast(res.msg)
                }
            })
        }
        // 修改单选框弹窗数据
        const changeReasonList = async (type: any) => {
            selectType = type
            if (type === 'status') {
                reasonRad.value = statusVal.id
                popTitle.value = 'Receipt status'
                reasonList.value = [{
                    title: "Received",
                    id: "1",
                }, {
                    title: "Unreceived",
                    id: "0",
                }]
                showAction.value = true
            } else if(type ==='reason'){
                popTitle.value = 'Reason for return'
                reasonRad.value = reasonVal.id
                let groupName = ''
                switch (serviceType.value.type) {
                    case '1':
                        groupName = 'return_refund'
                        break;
                    case '3':
                        groupName = 'repair'
                        break;
                    case '4':
                        groupName = 'exchange'
                        break;
                }
                if(serviceType.value.type == '2'){
                    if(infoData.value.statusVal == ""){
                        Toast('Please select the receipt status at first.')
                        return
                    }else{
                        groupName = infoData.value.statusVal == "Reaceived" ? "refund_recieve":"refund_not_recieve"
                    }
                }
                reasonList.value = reasonAllList.value[groupName]
                showAction.value = true
            }else if(type ==='type') {
                if(!route.params.id) return
                reasonList.value = serviceTypeList.value
                popTitle.value = 'Choose Service Type'
                reasonRad.value = serviceType.value.type
                statusVal = reasonVal = {
                    id: '',
                     title: ''
                }
                showAction.value = true
            }
        }
        const getReasonList = async()=>{
            let group_code = ['refund_recieve','refund_not_recieve','return_refund','repair','exchange']
            const res: any = await $http.getAfterSaleReasonList({ group_code })
                if (res.code === 200) {
                    // showAction.value = true
                    reasonAllList.value = res.data
                } else {
                    Toast(res.msg)
                }
        }
        // 操作商品数量
        const handleNum = (type: any,step:number, index?: any) => {
            let data =  goodsData.value[index].extra
            let max = 0
            let num =goodsData.value[index].editNum
            if(type == 'plus'){
                // 操作加号 
                goodsData.value[index].editNum += step
                maxKSH.value = infoData.value.KShVal = maxKSH.value + Number(data[num].pay_price)
            }else{
                // 操作减号
                goodsData.value[index].editNum -= step
                 for(let i = num - 1;i < goodsData.value[index].goods_num;i++){
                    max += Number(data[i].pay_price)
                }
                
                maxKSH.value = infoData.value.KShVal = defaultMaxKSU - max 
            }
            if(selectGoods.value.id) {
                selectGoods.value.goods_num = goodsData.value[index].editNum
            }
        }
        // 选中单选项操作
        const handleReasonRadio = (row: any) => {
            reasonRad.value = row.id
            if (selectType === 'status') {
                infoData.value.statusVal = row.title
                statusVal = row
                infoData.value.reasonVal = ''
            } else if(selectType ==='reason'){
                infoData.value.reasonVal = row.title
                reasonVal = row
            }else if(selectType ==='type'){
                serviceType.value = {
                    type: row.id,
                    title:row.title
                }
                selectGoods.value = {}
                infoData.value.statusVal = ''
                infoData.value.reasonVal = ''
                infoData.value.KShVal = needKSH.value ?   maxKSH.value:''
                getDropData()
            }
            showAction.value = false
        }
        // 关闭单选弹窗
        const sheetClose = () => {
            // reasonRad.value = ''
        }
        // 操作底部按钮
        const handleBtn = (item: any) => {
            if (item.title === "Apply") {
                // amountVer = true
                refForm.value.submit()
            } else {
                router.push(SkipPath.value)
            }
        }
        // 操作弹出sku弹窗
        const handleExchange = () => {
            skuShow.value = true
        }
        //获取商品详情信息
        let goodsInitFn = async (val: any) => {
            let res = await $http.detail(
                { id: val },
                common.getStorage("access_token") ? true : false
            );
            if (res.code === 200) {
                goods.value = res.data;
            }else{
                Toast({
                    message: res.message,
                    duration: 5000,
                })
            }
        }
        //选中商品规格后重新获取sku的数据
        let skuSelected = (val: number) => {
            skuId.value = val
        };
        // 选完商品后，点击ok
        let addCart = (val: number) => {
            isAddCart.value = true
            skuShow.value = false
            variation.value = true;
            if (val === 1) {
                variation.value = false;
            }
            getGoodsMsg()
        };
        //换货的商品规格信息
        let getGoodsMsg = async () => {
            selectGoods.value.sku_map = []
            selectGoods.value.goods_num = goodsData.value[0].editNum
            let list = goods.value.spec_list
            for (var i in list) {
                for (var n in list[i].spec_value) {
                    if (list[i].spec_value[n].spec_value_select == true) {
                        selectGoods.value.sku_map.push(list[i].spec_value[n].spec_value_name)
                    }
                }
            }
            selectGoods.value.sku_image = goods.value.images.XL
            selectGoods.value.sku_name = goods.value.name
            selectGoods.value.id = goods.value.id
        };
        // 获取上门取件的默认数据
        const getDropData = async () => {
            const res = await $http.post_address({ action: "select" });
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    if ((addressMsg.value && item.address_id == addressMsg.value) || (!addressMsg.value && item.is_default == 1)) {
                        setAddressData(item)
                    }
                });
            }
        }
        // 获取商品信息数据
        const getGoodsData = async () => {
            getReasonList()
            // 路由携带id则为编辑,反之则为新增
            if(!route.params.id){
                // 新增
                if (!afterGoodsData) {
                 router.push('/afterSale?name=state_apply')
                 return
                }
                let afterType = $store.getAfterType()
                serviceType.value = afterType
                SkipPath.value = `/afterSaleType/${afterGoodsData[0].order_goods[0].id}`
                 let arr:any = []
                afterGoodsData.forEach((item:any)=>{
                    arr = [].concat(arr,item.order_goods)
                })
                goodsData.value = arr
                orderId.value = goodsData.value[0].id
                goodsData.value.forEach((item: any) => {
                    item.editNum = item.goods_num
                    maxKSH.value += item.max_money
                    defaultMaxKSU += item.max_money
                });
                goodsInitFn(goodsData.value[0].sku_sn)
                infoData.value.KShVal = maxKSH.value
                if (!route.params.addressMsg) {
                    getDropData()
                }
            }else{
                // 编辑
                    SkipPath.value = "/afterSale?name=state_proces"
                    let arrs = [] as any
                    const detailRes: any = await $http.getAfterSaleDetail({ id: route.params.id })
                    if (detailRes.code === 200) {
                        let editData = detailRes.data.extra.common_info
                        getAfterSaleType(detailRes.data.order_goods[0].id,detailRes.data.available_check_id,editData.apply_info)
                        switch (editData.apply_info.provide_type) {
                            case '1':
                                serviceType.value = {
                                    type:'1',
                                    title:'Return & Refund'
                                }
                                break;
                            case '2':
                                serviceType.value = {
                                    type:'2',
                                    title:'Refund'
                                }
                                break;
                                // 目前售后2.0版本不支持售后维修 后期支持时，将信息修改为对于信息即可
                            // case '3':
                            //     serviceType.value = {
                            //         type:'3',
                            //         title:'Return & Refund'
                            //     }
                            //     break;
                            case '4':
                                serviceType.value = {
                                    type:'4',
                                    title:'Exchange'
                                }
                                break;
                        }
                        selectGoods.value = editData.apply_info.exchange_goods_info
                        if (!route.params.addressMsg) {
                            addressData.value = [editData.apply_info.receipt_info]
                        }
                        checksId.value = detailRes.data.available_check_id
                        infoData.value = {
                            teaxAreaVal: editData.apply_info.remark,
                            KShVal: editData.apply_info.refund_amount,
                            reasonVal: editData.apply_info.reason_title,
                            statusVal: editData.apply_info.receipt_status == '1' ? 'Reaceived' : 'Unreaceived'
                        }
                        statusVal = {
                            id: editData.apply_info.receipt_status,
                            title: editData.apply_info.receipt_status == '1' ? 'Reaceived' : 'Unreaceived'
                        }
                        reasonVal = {
                            id: editData.apply_info.reason_id,
                            title: editData.apply_info.reason_title
                        }
                       fileStorage.value = fileList.value =  editData.apply_info.attachments
                       
                    }
            }
            getRuleUrl().then((res: any) => {
                const { aftersale_rules }  = res.agreements
                ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
            })
        }
        
        getGoodsData()
        onActivated(() => {
            if (route.params.addressMsg) {
                // 从地址列表页面直接选择
                if (typeof JSON.parse(route.params.addressMsg as string) === 'object') {
                    setAddressData(JSON.parse(route.params.addressMsg as string))
                } else {
                    // 在地址列表页编辑之后返回当前页面
                    addressMsg.value = route.params.addressMsg as string
                    getDropData()
                }
            }
            if (!afterGoodsData) {
                router.push('/afterSale?name=state_apply')
            }
        })
        const handleUpload = (data: any) => {
            fileStorage.value.push(data)
        }
        const delFile = (file: any) => {
            fileStorage.value = file
        }

        const setAddressData = (address: any) => {
            addressData.value = [{
                path: '/afterSaleRefund/',
                leftIcon: 'location',
                title: `${address.firstname} ${address.lastname}`,
                explain: address.area_info ? (address.area_info + ',' + address.address) : ' ' + address.address,
                rightIcon: '',
                ...address
            }]
        }
        // 修改地址
        const editAddress = () => {
            $store.setGoBack('/afterSaleInfo')
            router.push({
                path: "/address-list",
                query: {
                    isShowCheck: addressData.value[0].address_id,
                },

            })
        }
        //表单校验弹框提示
        const onFailed = (errorInfo: any) => {
            Toast(errorInfo.errors[0].message);
        };
        // 提交表单
        const onSubmit = async () => {
            const afterType = serviceType.value.type
            const attachments = fileStorage.value.filter((item:any)=>!item.isGive)
            let params: any = {
                id: orderId.value,
                provide_type: afterType,// 售后类型:1-退货退款;2-退款;3-换货;4-维修
                receipt_status: statusVal.id || '', //货物状态0:未收货;1已收货,当provide_type为2时必传
                reason_id: reasonVal.id, // 售后原因id
                refund_amount: needKSH.value ? infoData.value.KShVal:'', // 退款金额
                attachments: attachments,//附件信息 attach_type: 附件类型:1-图片;2-视频    content: 附件内容 
                remark: infoData.value.teaxAreaVal,// 备注
                product_num: !isBatOnly.value ? goodsData.value[0].editNum : 0,//商品数量 为批量操作时，直接传0,不是批量操作时,传goodsData数组的第一个元素的商品数量
                exchange_goods_info: selectGoods.value ? JSON.parse(JSON.stringify(selectGoods.value)) : {}, // 换货是选择的商品信息
                receipt_info: afterType == '4' ?  addressData.value[0] : {},//买家信息
            }
            checksId.value ? params.check_id = checksId.value : ''
            // 当前为换货
            if(afterType == '4'){
                btnData.value[1].loading = false
                // 换货时不存在换货商品信息,则不能申请
                if(!selectGoods.value.id){
                     return Toast('Please select the goods to be replaced')
                }
                // 换货商品无库存
                if(!goods.value.storage){
                    return Toast('The exchange goods you selected is out of stock')
                }
            }
            if((['1','4'].includes(afterType)||afterType === '2'&&statusVal.id==='1')&&!attachments.length){
                return Toast('Please upload at least one photo or video proof.')
            }
            // 点击apply时才要校验金额是否为手动输入的金额,需要弹窗进行金额的二次确认
            // if(amountVer){
            //     if (afterType === '2'&&(needKSH.value&&infoData.value.KShVal === maxKSH.value)) {
            //         return showDialog.value = true
            //     } 
            //     if(['1','2'].includes(afterType) &&(needKSH.value&&infoData.value.KShVal < maxKSH.value)){
            //         return showaMountDialog.value = true
            //     }
            // }
            btnData.value[1].loading = true
            const res: any = await $http.setAfterSale(params)
            if (res.code === 200) {
                router.push({
                    path: "/afterSale",
                    query: {
                        name: 'state_proces'
                    }
                })
            } else {
                Toast(res.msg);
            }
            btnData.value[1].loading = false

        }
        const handleContinue = (confirmBoo:boolean) => {
            // amountVer = false
            showaMountDialog.value = false
            // confirmBoo 申请类型为退款,进行金额确认后,需要展示退款规则弹窗
            if(confirmBoo){
             showDialog.value = true
             return 
            }
            showDialog.value = false
            refForm.value.submit()
        }
        const goToRule = () => {
            if(ruleUrl.value){
                window.open(ruleUrl.value)
            }
        }
        // 校验当前输入金额是否大于最大金额,大于时进行提示
        const  validatorKSh = (val:any,rule:any) =>{
            if((val > maxKSH.value)||(val < 0)){
                rule.message = ' Please enter the correct amount.'
                return false
            }else{
                return true
            }
        }
        const handleNotConfirm = ()=>{
            showaMountDialog.value = false
            kshInputRef.value.focus()
        }
        watch(()=>skuId.value,()=>{
              goodsInitFn(skuId.value)
        })
        watch(()=> goods.value.id,(idVal:any)=>{
            // 当切换了sku中的商品规格时,请求有可能出现较为缓慢的现象,所以当goods下的id发生改变,并且isAddCart为true时再次对数据进行处理,确保换货商品显示的时选中的商品信息
            if(idVal == skuId.value&&isAddCart.value){
                getGoodsMsg()
                isAddCart.value = false
            }
            
        })
        onBeforeRouteLeave((to: any) => {
            if (to.path != "/address-list") {
                $store.setKeepAliveList([])
            } else {
                $store.setKeepAliveList(['afterSaleInfo'])
            }
        })
        return {
            refForm,SkipPath,goodsData,isBatOnly,showAction,serviceType,reasonRad,
            statusVal,reasonVal,reasonList,popTitle,addressData,fileList,skuShow,
            orderId,checksId,goods,selectGoods,infoData,addressMsg,imgPathData,
            showDialog,fileStorage,maxKSH,phoneCode,btnData,needKSH,showaMountDialog,
            variation,kshInputRef,
            changeReasonList,handleNum,handleReasonRadio,sheetClose,handleBtn,
            handleExchange,skuSelected,addCart,handleUpload,delFile,editAddress,
            onFailed,onSubmit,handleContinue,goToRule,validatorKSh,formatter,handleNotConfirm
        }
    }
}


